export const baseUrl = 'https://api.mazfund.ir/api'
export const fileBaseUrl = 'https://api.mazfund.ir'
export const chathubUrl = 'https://api.mazfund-mc.com/chathub'
export const tokenKey = 'mazfund-panel-jwttoken'
export const estateKey = 'mazfund-panel-estateKey'
export const notifPushy = '67975b7f591705551bbc6538'

export const APIS_ENDPOINTS = {
  dashboard: {
    getpaneldashboard: '/dashboard/getpaneldashboard',
  },
  authentincation: {
    login: '/personnel/login',
    getRoles: '/personnel/getroles',
    getProfile: '/personnel/getprofile',
    getUsersByRole: '/account/getusersbyrole',
    estatelogin: '/account/estatelogin',
    sendsmsforacceptcontractandverify: '/account/sendsmsforacceptcontractandverify',
    acceptcontractandverify: '/account/acceptcontractandverify',
  },
  personel: {
    upsertpersonnel: '/personnel/addpersonnel',
    datatable: '/personnel/datatable',
    editpersonnel: '/personnel/editpersonnel',
    blockUser: '/personnel/blockuser',
    unBlockUser: '/personnel/unblockuser',
    changepasswordbyadmin: '/personnel/changepasswordbyadmin',
    removeImageProfile: './personnel/removeprofileimage',
    deleteHiddenProfile: '/personnel/removehiddenprofileimage',
    removePersonelRole: '/personnel/removepersonnelrole',
    personelpass: '/personnel/personelpass',
    estatepass: '/personnel/estatepass',
    getusersbyrole: '/personnel/getpersonnelbyrole',
  },
  cartable: {
    upsertrequeststep: '/request/upsertrequeststep',
    getAll: '/cardboard/getall',
    getAllRequest: '/request/getall',
    accept: '/cardboard/acceptcardboard',
    addtocartable: '/cardboard/addreference',
    getallrequest: '/request/getallrequest',
    details: '/request/getdetail',
    addFootNote: '/footnote/addfootnote',
    changearchivecardboard: '/cardboard/changearchivecardboard',
    getAllArchiveBox: '/cardboard/getallarchivebox',
    completeRequest: '/request/completerequest',
    getallwaitinglist: '/cardboard/getallwaitinglist',
    waitingRequest: '/cardboard/changewaitinglistcardboard',
    changewaitinglistresponsetimecardboard: '/cardboard/changewaitinglistresponsetimecardboard',
    getmenucount: '/cardboard/getmenucount',
    getallcardboard72h: '/cardboard/getallcardboard72h',
    getallfootnote: '/footnote/getallfootnote',
    sendreferencetouser: '/cardboard/sendreferencetouser',
    addfile: '/requestfiles/addfile',
    getallrequestfile: '/requestfiles/getallrequestfile',
  },
  legalrequestfiles: {
    getalllegalrequestfiles: '/legalrequestfiles/getall',
    create: '/legalrequestfiles/create',
    edit: '/legalrequestfiles/edit',
    getalllegalrequesttype: '/legalrequesttype/getalllegalrequesttype',
    delete: '/legalrequestfiles/delete',
  },
  user: {
    getuserbyid: '/user/getuserbyid',
    changepasswordwithadmin: '/user/changepasswordwithadmin',
    adminLoginToUserWebApp: '/user/adminlogintouserwebapp',
    adduserposhetoken: '/user/adduserposhetoken',
    getalluser: '/user/getalluser',
    userprofile: '/userprofile',
    getallemployeeinsurancebyuserprofileid:
      '/employeeinsurance/getallemployeeinsurancebyuserprofileid',
    getallcompanyplacesbyuserprofileid: '/companyplaces/getallcompanyplacesbyuserprofileid',
    getallboardofdirectorsbyuserprofileid:
      '/boardofdirectors/getallboardofdirectorsbyuserprofileid',
    getalllegalshareholderbyuserprofileid:
      '/legalshareholder/getalllegalshareholderbyuserprofileid',
    editphonenumberbyadmin: '/user/editphonenumberbyadmin',
    editusertypebyadmin: '/user/editprofilebyadmin',
    disableboardofdirectorvalidation: '/userprofile/disableboardofdirectorvalidation',
    disablecompanystep2validation: '/userprofile/disablecompanystep2validation',
    disablecompanyvalidation: '/userprofile/disablecompanyvalidation',
    activecompanyvalidation: '/userprofile/activecompanyvalidation',
    activeboardofdirectorvalidation: '/userprofile/activeboardofdirectorvalidation',
  },
  setting: {
    getsettings: '/settings/getsettings',
    upsertsettings: '/settings/upsertsettings',
  },
  ticket: {
    adminanswer: '/ticket/adminanswer',
    detail: '/ticket/detail',
    changeticketstatus: '/ticket/changeticketstatus',
    datatable: '/ticket/datatable',
  },
  request: {
    getallrequestbyuserid: '/request/getallrequestbyuserid',
    rejectrequest: '/request/rejectrequest',
    getrequeststoppageperroleasync: '/request/getrequeststoppageperroleasync',
    exportrequeststoppageperroleasync: '/request/exportrequeststoppageperroleasync',
    exportrequestcountbyadminrole: '/request/exportrequestcountbyadminrole',
    getrequestcountbyadminrole: '/request/getrequestcountbyadminrole',
    imscompleterequest: '/request/imsnewcompleterequest',
    completerequest: '/request/completerequest',
    setmeetingrequest: '/request/setmeetingrequest',
  },
  contract: {
    upsertcontractrequest: '/contract/upsertcontractrequest',
    getcontractresource: '/contract/getcontractresource',
    addcontractresource: '/contract/addcontractresource',
    editcontractresource: '/contract/editcontractresource',
    deletecontractresource: '/contract/deletecontractresource',
    getcontractapplicant: '/contract/getcontractapplicant',
    getcontractsecurity: '/contract/getcontractsecurity',
    addcontractsecurity: '/contract/addcontractsecurity',
    editcontractsecurity: '/contract/editcontractsecurity',
    deletecontractsecurity: '/contract/deletecontractsecurity',
    getcontractdeposit: '/contract/getcontractdeposit',
    addcontractdeposit: '/contract/addcontractdeposit',
    editcontractdeposit: '/contract/editcontractdeposit',
    deletecontractdeposit: '/contract/deletecontractdeposit',
    getcontractpayment: '/contract/getcontractpayment',
    addcontractpayment: '/contract/addcontractpayment',
    editcontractpayment: '/contract/editcontractpayment',
    deletecontractpayment: '/contract/deletecontractpayment',
  },
  plans: {
    create: '/plans/create',
    edit: '/plans/edit',
    delete: '/plans/delete',
    getall: '/plans/getall',
    unactive: '/plans/unactive',
    active: '/plans/active',
  },
  letter: {
    sendbyadmin: '/letter/sendbyadmin',
    detail: '/letter/detail',
    datatable: '/letter/datatable',
    datatablebyuserid: '/letter/datatablebyuserid',
    getall: '/letter/getall',
    acceptletter: '/letter/acceptletter',
    getallletternote: '/letter/getallletternote',
    addreference: '/letter/addreference',
    sendreferencetouser: '/letter/sendreferencetouser',
    addnote: '/letter/addnote',
    archiveletter: '/letter/archiveletter',
  },
  transcript: {
    getall: '/transcript/getall',
    addtranscripts: '/transcript/addtranscripts',
    seentranscripts: '/transcript/seentranscripts',
    seenalltranscripts: '/transcript/seenalltranscripts',
    getallseentranscripts: '/transcript/getallseentranscripts',
  },
  requestZamen: {
    sendzamencount: '/requestzamen/sendzamencount',
    getallzamenbyrequestidpanel: '/requestzamen/getallzamenbyrequestidpanel',
    chanegzamenstatus: '/requestzamen/chanegzamenstatus',
    chanegzamenstatusplace: '/requestzamenplace/chanegzamenstatus',
    chanegzamenstatuslegal: '/requestzamenlegal/chanegzamenstatus',
    getallzamenbyrequestidpanelplace: '/requestzamenplace/getallzamenbyrequestidpanel',
    getallzamenbyrequestidpanellegal: '/requestzamenlegal/getallzamenbyrequestidpanel',
  },
  faq: {
    create: '/faq/create',
    edit: '/faq/edit',
    getlist: '/faq/getlist',
    active: '/faq/active',
    unactive: '/faq/unactive',
    delete: '/faq/delete',
  },
  surveyCategory: {
    create: '/surveycategory/create',
    edit: '/surveycategory/edit',
    getlist: '/surveycategory/getlist',
    active: '/surveycategory/active',
    unactive: '/surveycategory/unactive',
    delete: '/surveycategory/delete',
    setdefault: '/surveycategory/setdefaultforrequest',
  },
  survey: {
    create: '/survey/create',
    edit: '/survey/edit',
    getlist: '/survey/getlist',
    active: '/survey/active',
    unactive: '/survey/unactive',
    delete: '/survey/delete',
  },
  answersurvey: {
    getallsurvey: '/answersurvey/getallsurvey',
  },
  supportVideo: {
    create: '/supportvideo/create',
    edit: '/supportvideo/edit',
    getlist: '/supportvideo/getlist',
    active: '/supportvideo/active',
    unactive: '/supportvideo/unactive',
    delete: '/supportvideo/delete',
  },
  notifications: {
    getallnotification: '/notification/getallusernotification',
  },
  backCheques: {
    getallbackchequesbyuserprofileid: '/backcheques/getallbackchequesbyuserprofileid',
    getallboardofdirectorsbyuserprofileid:
      '/backchequesboardofdirectors/getallboardofdirectorsbyuserprofileid',
    getall: '/backcheques/getall',
  },
  facilityinquiry: {
    getallfacilityinquirybyuserprofileid: '/facilityinquiry/getallfacilityinquirybyuserprofileid',
  },
  facilityinquiryboardofdirectors: {
    getallboardofdirectorsbyuserprofileid:
      '/facilityinquiryboardofdirectors/getallboardofdirectorsbyuserprofileid',
  },
  requestzamencheques: {
    sendzamencheques: '/requestzamencheques/sendzamencheques',
    getallrequestzamencheques: '/requestzamencheques/getallrequestzamencheques',
    delete: '/requestzamencheques/delete',
  },
  archiveddocument: {
    create: '/archiveddocument/create',
    edit: '/archiveddocument/edit',
    deletefile: '/archiveddocument/deletefile',
    detail: '/archiveddocument/detail',
    datatable: '/archiveddocument/datatable',
  },
  validationPaymen: {
    getallpayment: '/validationpayment/getallpayment',
  },
}
